// logged-in.guard.ts
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SecurityRole, UserType } from '@jms/model';
import { ApplicationActions } from '@jms/tenant/module.jms.state';


@Injectable({ providedIn: 'root' })
export class HomeGuard {

    private role: SecurityRole;

    constructor(
        actions: ApplicationActions,
        private router: Router
    ) {
        actions
            .role$
            .subscribe(x => (this.role = x));
    }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        if (route.data.title === 'Home' && this.role?.type === UserType.SubcontractorCompany) {
            this.router.navigate(['/operations']);
            return false;
        }

        return true;
    }
}
